import type { JSX } from 'react';
import { useState } from 'react';
import { Button } from '@/components/ui/button';
import { Checkbox } from '@/components/ui/checkbox';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Label } from '@/components/ui/label';
import { CandidateConsentGate } from './CandidateConsentGate';

interface ConsentGateProps {
  onConsent: () => void;
  variant?: 'candidate' | 'referee';
}

export function ConsentGate({ onConsent, variant = 'referee' }: ConsentGateProps): JSX.Element {
  const [checked, setChecked] = useState(false);

  if (variant === 'candidate') {
    return <CandidateConsentGate onConsent={onConsent} />;
  }

  return (
    <div className="flex min-h-screen items-center justify-center px-4">
      <Card className="w-full max-w-md">
        <CardHeader className="text-center">
          <CardTitle>Before you continue</CardTitle>
        </CardHeader>
        <CardContent className="space-y-6">
          <div className="flex items-start gap-3">
            <Checkbox
              id="consent"
              checked={checked}
              onCheckedChange={(val) => setChecked(Boolean(val))}
            />
            <Label htmlFor="consent" className="leading-snug">
              I consent to the processing of my personal data as described in the{' '}
              <a
                className="text-primary underline underline-offset-4"
                href="/privacy"
                target="_blank"
                rel="noopener noreferrer"
              >
                Privacy Notice
              </a>
              , and I&apos;m over the age of 16.
            </Label>
          </div>
          <Button className="w-full" disabled={!checked} onClick={onConsent}>
            Continue
          </Button>
        </CardContent>
      </Card>
    </div>
  );
}
